interface NavigatorWithStandalone extends Navigator {
  standalone?: boolean
}

export function shouldRegisterServiceWorker(hostname = window.location.hostname) {
  const normalizedHostname = hostname.toLowerCase().replace(/^\[|\]$/g, '')

  return (
    normalizedHostname !== 'localhost' &&
    !normalizedHostname.endsWith('.localhost') &&
    !normalizedHostname.startsWith('127.') &&
    normalizedHostname !== '::1' &&
    normalizedHostname !== '0:0:0:0:0:0:0:1'
  )
}

export function isIosInstallDevice(userAgent = navigator.userAgent, platform = navigator.platform, maxTouchPoints = navigator.maxTouchPoints) {
  return /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && maxTouchPoints > 1)
}

export function isStandaloneApp() {
  return window.matchMedia('(display-mode: standalone)').matches || (navigator as NavigatorWithStandalone).standalone === true
}
